<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    class="tm-pc-detail-frame"
    style="width: 100%"
    v-if="selectedTm.length !== 0"
  >
    <print-preview-values v-if="type === 'values'"></print-preview-values>
    <print-preview-past v-if="type === 'past'"></print-preview-past>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 印刷プレビュー
 * PrintPreviewDetail.vue
 * @author LIS
 */
/** 観測値一覧印刷カード */
import PrintPreviewValues from "../../components/pc/full/PrintPreviewValues.vue";
import PrintPreviewPast from "../../components/pc/full/PrintPreviewPast.vue";
import util from "./../../lib/util";

export default {
  name: "print-preview-detail",
  components: {
    PrintPreviewValues,
    PrintPreviewPast,
  },
  computed: {
    /**
     * 観測所種別コード取得
     */
    itmkndCd: {
      get() {
        return this.$route.query.itmkndCd;
      },
    },
    /** 表示種別(values:観測値一覧,past:過去観測所) */
    type: {
      get() {
        return this.$route.query.type;
      },
    },
    /** 観測日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    /** 観測所情報取得 */
    selectedTm: {
      get() {
        if (this.itmkndCd === "300") {
          return this.$store.state.Swin.selectedSw;
        }
        return this.$store.state.Telemeter.selectedTm;
      },
    },
  },
  beforeCreate() {
    this.$log.debug("[TmObs] beforeCreate()");
    // 観測日時を設定
    if (this.$route.query["isCurrent"] == "false") {
      this.$store.commit("app/setTime", this.$route.query.appTime);
    } else {
      this.$store.commit("app/renewTime");
    }
  },
  methods: {
    // 観測所情報を取得
    getSelectedTm() {
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getSelectedTm", {
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
          appTime: this.appTime,
          appTimeRound: this.appTimeRound,
        });
      }, 500);
    },
    // 危機管理水位を取得
    getSelectedSw() {
      setTimeout(() => {
        this.$store.dispatch("Swin/getSelectedSw", {
          swobsCd: this.$route.query.obsCd,
          isCurrent: this.$route.query.isCurrent,
          appTime: this.appTime,
          appTimeRound: this.appTimeRound,
        });
      }, 500);
    },
    // 過去一週間情報を取得
    getPast() {
      this.$log.debug("[TmStageDetailPast] created()");
      this.yesterday = util.formatDate(
        util.subDays(this.appTime, 1),
        "YYYY-MM-DD"
      );
      if (this.itmkndCd === "1") {
        // 雨量
        this.$store.dispatch("Telemeter/getSelectedTmRainPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "2") {
        // 流域平均雨量
        this.$store.dispatch("Telemeter/getSelectedTmBsnPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "3") {
        // 積雪
        this.$store.dispatch("Telemeter/getSelectedTmSnowPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "4") {
        // 通常水位
        this.$store.dispatch("Telemeter/getSelectedTmStagePast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "6") {
        // 水質
        this.$store.dispatch("Telemeter/getSelectedTmWtrQualPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "7") {
        // ダム諸量
        this.$store.dispatch("Telemeter/getSelectedTmDamPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "12") {
        // 海岸
        this.$store.dispatch("Telemeter/getSelectedTmCoastPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      } else if (this.itmkndCd === "20" || this.itmkndCd === "21") {
        // レーダ流域
        this.$store.dispatch("Telemeter/getSelectedTmRdBsnPast", {
          date: this.appTime,
          ofcCd: this.$route.query.ofcCd,
          itmkndCd: this.$route.query.itmkndCd,
          obsCd: this.$route.query.obsCd,
        });
      }
    },
  },
  watch: {
    appTimeRound() {
      if (this.itmkndCd === "300") {
        this.getSelectedSw();
      } else {
        this.getSelectedTm();
      }
      if (this.type === "past") {
        this.getPast();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
